import React from "react";

import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export type ConfirmInputProps = {
  confirmInputMatch: string;
  confirmInputLabel: string;
};

type ConfirmDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmInput?: ConfirmInputProps;
};

const ConfirmationDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmInput,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const [confirmText, setConfirmText] = React.useState<string>("");

  return (
    <Dialog data-testid="dialog-modal" open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ wordBreak: "break-word" }}>{message}</DialogContentText>
        {confirmInput && (
          <>
            <DialogContentText sx={{ mt: "10pt" }}>{confirmInput.confirmInputLabel}</DialogContentText>
            <TextField
              sx={{ width: "100%" }}
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              data-testid="confirm-input"
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button data-testid="dialog-cancel-button" onClick={onClose}>
          Cancel
        </Button>
        <Button
          data-testid="dialog-confirm-button"
          disabled={confirmInput != null && confirmInput.confirmInputMatch !== confirmText}
          onClick={handleConfirm}
          autoFocus
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
